import { DialogTitle, IconButton, Slider, Tooltip } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { Controller, FormProvider, useForm, useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { languageSelector } from 'slices/languageSlice';
import { Select, selectCustomStyles } from './common/Select';
import ErrorMessage from './common/ErrorMessage';
import moment from 'moment';
import { SubmitButton } from './common/buttons/SubmitButton';
import { setError } from 'slices/sessionSlice';
import { AsyncPaginate } from 'react-select-async-paginate';
import Swal from 'sweetalert2';
import { fetchFacilities } from 'slices/facilitiesSlice';
import { fetchDepartments } from 'slices/departmentSlice';
import { updateSession } from 'slices/sessionSlice';
import { addSession } from 'slices/sessionSlice';
import toast from 'react-hot-toast';
import { fetchSessions } from 'slices/sessionSlice';
import { useNavigate } from 'react-router-dom';
import { sessionsSelector } from 'slices/sessionSlice';
import { facilitiesSelector } from 'slices/facilitiesSlice';
import { departmentsSelector } from 'slices/departmentSlice';
import { Spinner } from 'reactstrap';
import { BootstrapDialog } from './subUsers/AddSubUsers';
import MultiToggleSwitch from './MultiToggleSwitch';
import LanguageTabs from './LanguageTabs';
import { fetchLocations } from 'slices/locationSlice';
import { setDepartments } from 'slices/departmentSlice';
import { setFacilities } from 'slices/facilitiesSlice';
import { setLoader } from 'slices/sessionSlice';
import { filterPatient } from 'slices/patientSlice';

//#region OPTIONS ARRAYS
export const businessDivisionOptions = [
    { value: 'Castell', label: 'Castell' },


    { value: 'Intermountain', label: 'Intermountain' },
    { value: 'Medical Group', label: 'Medical Group' },
    { value: 'Tellica', label: 'Tellica' },
];

export const priorityLevelOptions = [
    { value: 'Regular', label: 'Regular' },
    { value: 'High', label: 'Higher Priority' },
    { value: 'Low', label: 'Lower Priority' },
];

export const encounterTypeOptions = [
    { value: 'In Person', label: 'In Person' },
    { value: 'VRI', label: 'VRI' },
    { value: 'OPI', label: 'OPI' },
    { value: 'OPI On Demand', label: 'OPI On Demand' },
];

export const encounterSourceOptions = [
    { value: 'Revenue Cycle', label: 'Revenue Cycle' },
    { value: 'Service Hub', label: 'Service Hub' },
    { value: 'Telephonic', label: 'Telephonic' },
    { value: "Manual", label: 'Manual' },
    { value: "List", label: 'List' },
    { value: 'Other', label: 'Other' },
];

export const jobTypesOptions = [
    { value: 'Assign', label: 'Assign' },
    { value: 'Escalation', label: 'Escalation' },
    { value: 'Open', label: 'Open' },
];

export const statusOptions = [
    { value: 'Billed', label: 'Billed' },
    { value: 'Dispute', label: 'Dispute' },
    { value: 'Paid', label: 'Paid' },
]
//#endregion

export const SessionForm = ({ handleClose, item, afterUpdated, callBack, isDuplicate = false, itsBootstrap = true, isNew = false, append = false, values }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const { facilities } = useSelector(facilitiesSelector);
    const { departments } = useSelector(departmentsSelector);
    const methods = useForm();
    const { setFocus, handleSubmit, watch, formState: { errors }, control, setValue, setError: setErrors, clearErrors, getValues } = methods
    const { error, appointments: scheduleLists } = useSelector(sessionsSelector);
    const [loaderState, setLoaderState] = React.useState(false);
    const [mrnLoader, setMrnLoader] = React.useState(false);
    const [sessionType, setSessionType] = React.useState('On Demand');
    const [selectedLanguage, setSelectedLanguage] = useState(1);
    //#region  CLEAR UP ALL FIELDS
    const clearAllFields = React.useCallback(() => {
        setValue("location_id", '');
        setValue("facility_id", '');
        setValue("department_id", '');
        setValue("call_type", 'video');
        setValue("date", moment(new Date()).format('YYYY-MM-DD'));
        setValue("time", moment().format("HH:mm"));
        setValue("requester_name", "");
        setValue("requester_email", "");
        setValue('mrn_number', '')
        setValue('patient_name', '')
        setValue('birth_date', '')
        clearErrors();
        dispatch(setError({}))
        dispatch(setLoader(false))
    }, []);
    //#endregion

    //#region useEffects
    React.useEffect(() => {
        setValue("location_id", item?.location_id || '');
        setValue("facility_id", item?.facility_id || '');
        setfilterFacilities({
            label: item?.facility?.abbreviation || "",
            value: item?.facility?.id || ""
        })
        setValue("department_id", item?.department_id || '');
        setFilterDepartments({
            label: item?.department?.user?.name || "",
            value: item?.department?.id || ""
        })
        setValue("call_type", item?.call_type || 'video');
        setValue("date", item?.date || moment(new Date()).format('YYYY-MM-DD'));
        setValue("time", item?.time || moment().format("HH:mm"));
        setValue("requester_name", item?.appointment_details?.requester_name || "");
        setValue("mrn_number", item?.appointment_details?.mrn_number || '')
        setValue("patient_name", item?.appointment_details?.patient_name || '')
        setValue("birth_date", item?.appointment_details?.birth_date || '')
    }, [item?.appid]);
    //#endregion

    //#region FETCH MRN NUMBER
    const fetchMRN = React.useCallback(() => {
        console.log("helo")
        if (!watch("mrn_number")) {
            clearErrors("mrn_number")
            setValue("patient_name", "");
            setValue("birth_date", "");
            setValue("provider_name", "");
            setValue("medicaid_id", "");
            setValue("medicaid_plan", "");
            return
        }
        clearErrors("mrn_number")
        const callback = (success, values) => {
            if (success) {
                setValue("patient_name", values?.patient_name);
                setValue("birth_date", values?.birth_date)
                setValue("provider_name", values?.provider_name);
                setValue("medicaid_id", values?.medicaid_id);
                setValue("medicaid_plan", values?.medicaid_plan);

                clearErrors("mrn_number");
                clearErrors("patient_name");
                clearErrors("birth_date");
                clearErrors("provider_name");
                clearErrors("medicaid_id");
                clearErrors("medicaid_plan");
            }
            else {
                setErrors("mrn_number", { message: "There is no Patient Available on this MRN, please create a new one" })
            }
        }
        dispatch(filterPatient({ mrn_number: watch("mrn_number") }, callback));
    }, [watch("mrn_number")]);
    //#endregion

    useEffect(() => {
        setValue('facility_id', facilities?.find(i => i?.id === watch('facility_id'))?.id || '')
        setValue('department_id', departments?.find(i => i?.id === watch('department_id'))?.id || '')
    }, [watch('facility_id'), watch('department_id')])


    //#region SUBMIT FORM
    const submitCallback = (status, message, data) => {
        if (status) {
            toast.success(message, {
                className: "successToast",
            })
            clearAllFields()
            handleClose();
            setLoaderState(false)
            Swal.fire({
                title: "Success!",
                text: message,
                icon: "success"
            }).then(() => {
                // navigate(`/sessions/view/${data?.id}`);
            })
        }
        else {
            console.log('onSubmit', error)
            toast.error(message,
                {
                    className: "errorToast",
                }
            );
            setTimeout(() => {
                setLoaderState(false)
            }, 1000);
        }
    };
    const onSubmit = React.useCallback((data) => {
        dispatch(setError({}))
        setLoaderState(true)

        data = {
            ...data,
            type: sessionType,
            language_id: selectedLanguage,
        }
        const newData = {}
        for (const key in data) {
            if (Object.prototype.hasOwnProperty.call(data, key)) {
                if (data[key])
                    newData[key] = data[key]
            }
        }

        if (item?.id) {
            dispatch(updateSession(newData, item?.id, submitCallback, true));
        }
        else {
            dispatch(addSession(newData, submitCallback, true));
        }

    }, [item, sessionType,]);


    const scrollToError = (fieldName) => {
        const element = document.querySelector(`[name="${fieldName}"]`);
        if (element) {
            const parentContainer = document.querySelector('#scheduleEncounter'); // Replace with your container class
            if (parentContainer) {
                const offsetTop = element.offsetTop - parentContainer.offsetTop;
                parentContainer.scrollTo({
                    top: offsetTop,
                    behavior: 'smooth',
                });
            }
            // element.scrollIntoView({ behavior: "smooth", block: "center" });
            setFocus(fieldName); // Focus the field
        }
    };

    const onError = (error) => {
        const firstErrorField = Object.keys(error)[0];
        if (firstErrorField) scrollToError(firstErrorField);
    };


    //#endregion

    const location_id = watch("location_id");

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === 'location_id') {
                setfilterFacilities(null);
                setFilterDepartments(null);
                setValue('facility_id', null);
                setValue('department_id', null);
            }
        });

        return () => subscription.unsubscribe();
    }, [watch, setValue]);

    // #region client dropdown 
    const [filterLocations, setfilterLocations] = useState({
        label: "",
        value: ""
    })

    useEffect(() => {
        if (item?.accounts?.user?.name && item?.accounts?.user?.id) {
            setfilterLocations({
                label: item?.accounts?.user?.name || "",
                value: item?.accounts?.user?.id || ""
            })
        } else {
            setfilterLocations(null)
        }
    }, [item?.accounts?.user])

    const filteredLocationLoadOptions = async (inputValue, loadedOptions, { page }) => {
        const result = await dispatch(fetchLocations(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));
        return {
            options: result.data.map(val => ({
                value: val.id,
                label: val?.user?.name,
            })),

            hasMore: page !== result?.last_page,
            additional: {
                page: page + 1,
            },
        };
    };
    //#endregion

    // #region Facility dropdown 
    const [filterFacilities, setfilterFacilities] = useState({})

    useEffect(() => {
        if (item?.facility?.abbreviation && item?.facility?.id) {
            setfilterFacilities({
                label: item?.facility?.abbreviation || "",
                value: item?.facility?.id || ""
            })
        } else {
            setfilterFacilities(null)
        }
    }, [item?.facility])

    //#endregion

    // #region Department dropdown 
    const [filterDepartments, setFilterDepartments] = useState({})

    useEffect(() => {
        if (item?.department?.name && item?.department?.id) {
            setFilterDepartments({
                label: item?.department?.name || "",
                value: item?.department?.id || ""
            })
        } else {
            setFilterDepartments(null)
        }
    }, [item?.department])


    //#endregion

    const handleDropdownChange = (val) => {
        setSessionType(val);
    }

    return (
        <FormProvider {...methods} >
            <form>
                {/* INPUTS */}
                <>
                    <div className="foam_page_row">
                        <div className='flex-basis-full d-flex justify-content-center pb-4'>
                            <MultiToggleSwitch
                                type={'simple'}
                                options={[
                                    { label: 'On Demand', value: 'On Demand' },
                                    { label: 'Scheduled', value: 'Scheduled' },
                                ]}
                                defaultValue={item?.type == 'Scheduled' ? 'Scheduled' : 'On Demand'}
                                onChange={(selected) => handleDropdownChange(selected)}
                            />
                        </div>

                        {/* Location SELECT */}
                        <div className="row-primary row_secondary">
                            <h2>Location *</h2>
                            <div className='w-100'>
                                <Controller
                                    name="location_id"
                                    control={control}
                                    rules={{
                                        required: "Please select a location"
                                    }}
                                    render={({ field }) =>
                                        <div style={{ width: "100%" }}>
                                            <AsyncPaginate
                                                menuPlacement='auto'
                                                styles={{
                                                    ...selectCustomStyles,
                                                }}
                                                value={filterLocations}
                                                loadOptions={filteredLocationLoadOptions}
                                                isClearable
                                                escapeClearsValue
                                                onChange={(obj) => {
                                                    if (obj?.value) {
                                                        setfilterLocations(obj)
                                                        field.onChange(obj.value);
                                                        dispatch(fetchFacilities(1, { location_id: obj.value, pageLength: 1000, sortBy: "id", sortDirection: "asc" }));
                                                        dispatch(fetchDepartments(1, { location_id: obj.value, pageLength: 1000, sortBy: "id", sortDirection: "asc" }));
                                                    }
                                                    else {
                                                        setfilterLocations(null)
                                                        dispatch(setFacilities([]))
                                                        dispatch(setDepartments([]))
                                                        field.onChange(null);
                                                    }
                                                }}
                                                additional={{
                                                    page: item?.state?.id ? 2 : 1,
                                                }}
                                            />
                                            {errors?.location_id?.message &&
                                                <div style={{ marginBottom: 10 }}>
                                                    <ErrorMessage text={errors?.location_id?.message} />
                                                </div>
                                            }
                                        </div>
                                    }
                                />
                            </div>
                        </div>

                        {/* FACILITY SELECT */}
                        <div className="row-primary row_secondary">
                            <h2>Facility Name *</h2>
                            <div className='w-100'>
                                <Controller
                                    name="facility_id"
                                    control={control}
                                    rules={{
                                        required: "Please select a facility"
                                    }}
                                    render={({ field }) =>
                                        <div style={{ width: "100%" }}>
                                            <Select
                                                menuPlacement='auto'
                                                styles={{ ...selectCustomStyles }}
                                                value={filterFacilities}
                                                options={
                                                    facilities.map(i => ({
                                                        label: i.abbreviation || '',
                                                        value: i.id || '',
                                                    }))
                                                }
                                                isClearable
                                                onChange={(obj) => {
                                                    if (obj) {
                                                        field.onChange(obj);
                                                        const selectFacility = facilities?.find(i => i?.id === obj);
                                                        setfilterFacilities({
                                                            label: selectFacility?.abbreviation,
                                                            value: selectFacility?.id,
                                                        });
                                                    } else {
                                                        setfilterFacilities(null);
                                                        field.onChange(null);
                                                    }
                                                }}
                                            />
                                            {errors?.facility_id?.message &&
                                                <div style={{ marginBottom: 10 }}>
                                                    <ErrorMessage text={errors?.facility_id?.message} />
                                                </div>
                                            }
                                        </div>
                                    }
                                />
                            </div>
                        </div>

                        {/* DEPARTMENT SELECT */}
                        <div className="row-primary row_secondary">
                            <h2>Department Name *</h2>
                            <div className='w-100'>
                                <Controller
                                    name="department_id"
                                    control={control}
                                    rules={{
                                        required: "Please select a department"
                                    }}
                                    render={({ field }) =>
                                        <div style={{ width: "100%" }}>
                                            <Select
                                                menuPlacement='auto'
                                                styles={{ ...selectCustomStyles }}
                                                value={filterDepartments}
                                                options={
                                                    departments?.map(i => ({
                                                        label: i?.user?.name || '',
                                                        value: i.id || '',
                                                    }))
                                                }
                                                isClearable
                                                onChange={(obj) => {
                                                    if (obj) {
                                                        field.onChange(obj);
                                                        const selectDepartment = departments?.find(i => i?.id === obj);
                                                        setFilterDepartments({
                                                            label: selectDepartment?.user?.name,
                                                            value: selectDepartment?.id,
                                                        });
                                                    } else {
                                                        setFilterDepartments(null);
                                                        field.onChange(null);
                                                    }
                                                }}
                                            />
                                            {errors?.department_id?.message &&
                                                <div style={{ marginBottom: 10 }}>
                                                    <ErrorMessage text={errors?.department_id?.message} />
                                                </div>
                                            }
                                        </div>
                                    }
                                />
                            </div>
                        </div>


                        {/* DATE TIME INPUT */}

                        <LanguageTabs setSelectedLanguage={setSelectedLanguage} selectedLanguage={selectedLanguage} />

                        <CallTypeTabs errors={errors} control={control} />

                        {sessionType == 'Scheduled' &&
                            <>
                                <DateTimeInputs isDuplicate={isDuplicate} isNew={isNew} />

                                {/* REQUESTER */}
                                <div className="row-primary row_secondary">
                                    <h2>Requestor *</h2>
                                    <div className="w-100">
                                        <Controller
                                            name="requester_name"
                                            rules={{
                                                required: 'Requestor name is required'
                                            }}
                                            control={control}
                                            render={({ field }) =>
                                                <input
                                                    className="input-in type_inp"
                                                    type="text"
                                                    {...field}
                                                />
                                            }
                                        />
                                        {errors?.requester_name?.message &&
                                            <div style={{ marginBottom: 10 }}>
                                                <ErrorMessage text={errors?.requester_name?.message} />
                                            </div>
                                        }
                                    </div>
                                </div>

                                {/* REQUESTOR EMAIL */}
                                <div className="row-primary row_secondary">
                                    <h2>Requestor Email *</h2>
                                    <div className="w-100">
                                        <Controller
                                            name="requester_email"
                                            rules={{
                                                required: 'Requestor email is required'
                                            }}
                                            control={control}
                                            render={({ field }) =>
                                                <input
                                                    className="input-in type_inp"
                                                    type="email"
                                                    pattern={
                                                        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                                                    }
                                                    {...field}
                                                />
                                            }
                                        />
                                        {error?.errors?.requester_email?.map((error) => (
                                            <div style={{ marginBottom: 10 }}>
                                                <ErrorMessage text={error} />
                                            </div>
                                        ))}
                                        {errors?.requester_email?.message &&
                                            <div style={{ marginBottom: 10 }}>
                                                <ErrorMessage text={errors?.requester_email?.message} />
                                            </div>
                                        }
                                    </div>
                                </div>

                                {/* MRN NUMBER */}
                                <div className="row-primary row_secondary">
                                    <h2>MRN Number *</h2>

                                    <Controller
                                        name="mrn_number"
                                        control={control}
                                        rules={{
                                            required: 'MRN number is required'
                                        }}
                                        disabled={mrnLoader}
                                        render={({ field }) =>
                                            <div style={{ width: "100%" }}>
                                                <div className="input-image">
                                                    <input id='mrn_number' type="text" name='mrn_number'
                                                        // className="input-in type_inp"
                                                        placeholder='MRN Number'
                                                        {...field}
                                                        disabled={mrnLoader}
                                                    />

                                                    <Tooltip title="Click to get Patient Details">
                                                        <IconButton type='button' aria-label="delete" disabled={!watch("mrn_number") || mrnLoader} onClick={fetchMRN}>

                                                            {
                                                                mrnLoader ?
                                                                    <Spinner size={"sm"} color='primary' type="grow" /> :
                                                                    <h2 style={{ color: "#777682", minWidth: "auto", marginTop: 0 }} onPress={fetchMRN}>Fetch</h2>
                                                            }
                                                        </IconButton>
                                                    </Tooltip>
                                                </div>
                                                {errors?.mrn_number?.message &&
                                                    <div style={{ marginBottom: 10 }}>
                                                        <ErrorMessage text={errors?.mrn_number?.message} />
                                                    </div>

                                                }
                                            </div>
                                        } />
                                </div>

                                {/* PATIENT NAME */}
                                <div className="row-primary row_secondary">
                                    <h2>Patient Name *</h2>
                                    <Controller
                                        name="patient_name"
                                        control={control}
                                        rules={{
                                            required: 'Patient name is required'
                                        }}
                                        render={({ field }) =>
                                            <div style={{ width: "100%" }}>
                                                <input
                                                    className="input-in type_inp"
                                                    type="text"
                                                    {...field}
                                                />

                                                {errors?.patient_name?.message &&
                                                    <div style={{ marginBottom: 10 }}>
                                                        <ErrorMessage text={errors?.patient_name?.message} />
                                                    </div>

                                                }
                                            </div>
                                        }
                                    />
                                </div>

                                {/* BIRTH DATE */}
                                <div className="row-primary row_secondary">
                                    <h2>Birth Date</h2>
                                    <Controller
                                        name="birth_date"
                                        control={control}
                                        rules={{
                                            required: 'Birth date is required'
                                        }}
                                        render={({ field }) =>
                                            <div style={{ width: "100%" }}>
                                                <div className="input-image">
                                                    <input id='birth_date' type="date" name='birth_date'
                                                        placeholder='YYYY-MM-DD'
                                                        {...field}
                                                        value={field.value ? field?.value : ""}
                                                        onPaste={(e) => {
                                                            e.preventDefault(); // Prevent default paste behavior
                                                            const pastedData = e.clipboardData.getData("text"); // Get pasted text
                                                            const dateString = moment.utc(pastedData).format("YYYY-MM-DD");

                                                            if (moment(dateString, "YYYY-MM-DD", true).isValid()) {
                                                                field.onChange(dateString);
                                                            } else {
                                                                console.warn("Invalid date format");
                                                            }
                                                        }}
                                                        onChange={(e) => {
                                                            const dateString = moment.utc(e.target.value).format('YYYY-MM-DD')
                                                            field.onChange(dateString)
                                                        }}
                                                    />
                                                    <img src="/images/celender.png" alt="celender Icon" className="custom-icon" />

                                                </div>
                                                {errors?.birth_date?.message &&
                                                    <div style={{ marginBottom: 10 }}>
                                                        <ErrorMessage text={errors?.birth_date?.message} />
                                                    </div>
                                                }
                                            </div>
                                        } />

                                </div>
                            </>

                        }

                    </div>
                </>

                {/* ERROR MESSAGES */}
                {Object.keys(errors)?.length > 0 && (
                    <div className='row-primary align-center'>
                        <i class="fa-solid fa-circle-exclamation mt-2 error-color "></i>
                        <ErrorMessage fontWeight={"bold"} text={"Please fill all mandatory fields"} />
                    </div>
                )}

                <div className="Form-footer">
                    <button type="button" className="Cancle_button" data-bs-dismiss={itsBootstrap ? "modal" : ""} onClick={handleClose}>Cancel</button>
                    <SubmitButton
                        btnText='Submit Request'
                        buttonType="button"
                        handleSubmit={handleSubmit(onSubmit, onError)}
                        loader={loaderState}
                    />
                </div>

            </form>
        </FormProvider>
    );
};


const DateTimeInputs = ({ isDuplicate, isNew }) => {
    const { control, formState, setValue, watch } = useFormContext();
    return (
        <>
            <div className="row-primary row_secondary">
                <h2>Date*</h2>
                <Controller
                    name="date"
                    control={control}
                    rules={{
                        required: "Please select date"
                    }}
                    render={({ field }) =>
                        <div>
                            <div className="input-image">
                                <input id='date' type="date" name='date' placeholder='Date' required
                                    {...field}
                                    value={field.value ? field.value : ""}
                                    onChange={(e) => {
                                        const dateString = e.target.value ? moment.utc(e.target.value).format('YYYY-MM-DD') : ""
                                        field.onChange(dateString);

                                        if (watch("available_status")) {
                                            if (isDuplicate || isNew) {
                                                setValue("checkin_date", watch("date"));
                                                setValue("checkout_date", watch("date"));
                                            }
                                        }
                                    }}
                                />
                                <img src="/images/celender.png" alt="celender Icon" className="custom-icon" />

                            </div>
                            {formState?.errors?.date?.message &&
                                <div style={{ marginBottom: 10 }}>
                                    <ErrorMessage text={formState?.errors?.date?.message} />
                                </div>
                            }



                        </div>
                    } />
            </div>
            <div className="row-primary row_secondary">

                <h2>Time*</h2>
                <Controller
                    name="time"
                    control={control}
                    rules={{
                        required: "Please select start time"
                    }}
                    render={({ field }) =>
                        <div>
                            <div className="input-image">
                                <input
                                    type="time"
                                    name='time'
                                    placeholder='hh:mm'
                                    {...field}
                                    value={moment(field.value, ["h:mm A"]).format("HH:mm")}
                                    onChange={
                                        (e) => {
                                            // const timeString = moment.utc(e.target.value, ["HH:mm"]).format("HH:mm");
                                            field.onChange(e.target.value);
                                            if (watch("available_status")) {
                                                if (isDuplicate || isNew) {
                                                    setValue("checkin_time", watch("time"));
                                                    // and checkout_time shoudld be 15 mins above time
                                                    const duraton = watch("duration");
                                                    const checkout_time = moment(e.target.value, ["HH:mm"]).add(duraton, 'minutes').format("HH:mm")
                                                    setValue("checkout_time", checkout_time);
                                                    // and checkout_date should be same as date
                                                }
                                            }

                                        }
                                    }
                                    // value={field.value}
                                    required
                                />
                                <img src="/images/clock.png" alt="Clock Icon" className="custom-icon" />
                            </div>
                            {formState?.errors?.time?.message &&
                                <div style={{ marginBottom: 10 }}>
                                    <ErrorMessage text={formState?.errors?.time?.message} />
                                </div>
                            }
                        </div>
                    }
                />
            </div>
        </>
    )
}

const CallTypeTabs = ({ control, errors }) => {
    const [selected, setSelected] = useState('video');

    const handleSelect = (type, onChange) => {
        setSelected(type);
        onChange(type);
    };


    return (
        <>
            <div className="row-primary row_secondary flex-basis-full  pt-2">
                <h2>Select Call</h2>
                <Controller
                    name="call_type"
                    control={control}
                    rules={{
                        required: "Please select a call type"
                    }}
                    render={({ field }) =>
                        <div style={{ width: "100%" }}>
                            <div className="tab-container">
                                <label
                                    className={`tab-option ${selected === 'video' ? 'selected' : ''}`}
                                    onClick={() => handleSelect('video', field.onChange)}
                                >
                                    <input
                                        type="radio"
                                        name="call_type"
                                        value="video"
                                        checked={selected === 'video'}
                                        onChange={() => handleSelect('video', field.onChange)}
                                    />
                                    <i className="fas fa-video"></i>
                                </label>

                                <label
                                    className={`tab-option ${selected === 'audio' ? 'selected' : ''}`}
                                    onClick={() => handleSelect('audio', field.onChange)}
                                >
                                    <input
                                        type="radio"
                                        name="call_type"
                                        value="audio"
                                        checked={selected === 'audio'}
                                        onChange={() => handleSelect('audio', field.onChange)}
                                    />
                                    <i className="fas fa-microphone"></i>
                                </label>
                            </div>
                            {errors?.call_type?.message &&
                                <div style={{ marginBottom: 10 }}>
                                    <ErrorMessage text={errors?.call_type?.message} />
                                </div>
                            }
                        </div>
                    }
                />

            </div>
        </>
    );
}

export const AddSessionModal = ({ item, afterUpdated, onClose, show }) => {
    const handleCloseScheduleForm = () => {
        onClose(item?.id, item?.status);
    }

    return (
        <BootstrapDialog
            fullWidth={true}
            maxWidth={"md"}
            onClose={onClose}
            aria-labelledby="customized-dialog-title"
            open={show}
        >
            <div className="">
                <div className="modal-content full_modal">
                    <DialogTitle>
                        <div className='d-flex gap-3'>
                            <h5 className="modal-title_u">Create Session</h5>
                            <button type="button" className="btn-close" aria-label="Close" onClick={() => { onClose(item?.id, item?.status) }}></button>
                        </div>
                    </DialogTitle>
                    <div className="modal-body modal_form_body" style={{paddingTop: 0}}>
                        <SessionForm handleClose={handleCloseScheduleForm}
                            item={item}
                            isDuplicate={true}
                            itsBootstrap={false}
                            afterUpdated={() => {
                                afterUpdated(item?.id, item?.status)
                            }} />
                    </div>
                </div>
            </div>
        </BootstrapDialog>
    )
}